import React, { useEffect, useState } from "react";
import { CustomTooltip } from "../../components/CustomTooltip";
import { Spinner } from "react-bootstrap";
import { getAssetTransferRequest } from "../../services/AssetService";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import { Link } from "react-router-dom";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { MdCancel } from "react-icons/md";
import Pagination from "../Constant/Pagination";
import { CancelRequest } from "../../services/AxiosInstance";
import EmployeeAssetTransferAction from "./EmployeeAssetTransferAction";
import { format } from "date-fns";
import { FaInfo } from "react-icons/fa";
import { getTransferStatusBadge } from "../../utilities";
const AssetTransferRequest = () => {
  const [assets, setAssets] = useState([]);
  const [actionType, setActionType] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [total, setTotal] = useState(0);
  const [selecetdData, setSelectedData] = useState(null);
  const [param, setParam] = useState({
    page: "1",
    page_size: "10",
    query: "",
  });

  const fetchRequestedAssets = async () => {
    setLoading(true);
    try {
      const resp = await getAssetTransferRequest(param);
      setError("");
      const data = resp?.data?.results || [];
      setAssets(data);
      setTotal(resp?.data?.count || 0);
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.response?.data?.error ||
          "Try again later"
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequestedAssets();
  }, [param]);

  const handleToggleModal = () => {
    setShowModal(!showModal);
    // if (showModal) {
    //   setSelectedData(null);
    //   setActionType("");
    // }
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: "1",
    }));
  };
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleAfterTransferActionSubmit = () => {
    handleToggleModal();
    fetchRequestedAssets();
  };
  return (
    <>
      <div className="mb-3">
        <h2 className="text-primary">Assets Transfer Requests</h2>
        <ol className="breadcrumb breadcrumb-arrow mb-0">
          <li className="breadcrumb-item">
            <Link to="/dashboard">Dashboard</Link>
          </li>
          <li className="breadcrumb-item active">Transfer Requests</li>
        </ol>
      </div>

      <div className="card">
        <div className="d-flex justify-content-between flex-column flex-md-row gap-2 px-4 py-3">
          <div className="flex-fill flex-md-grow-0">
            <DebounceSearchInput handleSearchChange={handleSearchChange} />
          </div>
        </div>

        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" />
          </div>
        ) : error ? (
          <div className="text-center text-danger my-4">{error}</div>
        ) : assets && assets.length > 0 ? (
          <div className="table-responsive">
            <table className="table fs-6 mb-0 align-middle">
              <thead className="table-light custom-thead">
                <tr>
                  <th>Asset Number</th>
                  <th>Asset Name</th>
                  <th>Transfer From</th>
                  <th>Remark</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {assets.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="text-center">
                      No assets found
                    </td>
                  </tr>
                ) : (
                  assets.map((item, idx) => (
                    <tr key={item?.id || idx}>
                      <td>{item.asset?.asset_number || "-"}</td>
                      <td>
                        <div className="d-flex align-items-center gap-1 cursor-pointer">
                          <span>{item?.asset?.name || "-"}</span>
                          <CustomTooltip
                            title={
                              <div>
                                <div>
                                  <strong>Purchase Cost:</strong>{" "}
                                  {`₹${item?.asset?.purchase_cost}` || "-"}
                                </div>
                                <div>
                                  <strong>Manual Asset ID:</strong>{" "}
                                  {item?.asset?.manual_asset_id || "-"}
                                </div>
                                <div>
                                  <strong>Model No.:</strong>{" "}
                                  {item?.asset?.model_number || "-"}
                                </div>
                                <div>
                                  <strong>Brand:</strong>{" "}
                                  {item?.asset?.brand || "-"}
                                </div>
                              </div>
                            }
                            placement="right"
                          >
                            <span
                              className="rounded-1 ms-1 btn btn-sm btn-outline-light"
                              style={{
                                cursor: "pointer",
                                padding: "0.2rem 0.2rem",
                              }}
                            >
                              <FaInfo size={9} className="text-dark" />
                            </span>
                          </CustomTooltip>
                        </div>
                      </td>
                      <td>{item.from_employee?.name || "-"}</td>
                      <td>{item.remarks || "-"}</td>
                      <td>
                        {item.requested_at
                          ? format(item.requested_at, "dd MMM yyy")
                          : "-"}
                      </td>
                      <td>
                        {getTransferStatusBadge(item.movement_status || "-")}
                      </td>
                      <td>
                        <div className="d-flex gap-2">
                          <CustomTooltip title="Accept" placement="top">
                            <button
                              className="btn btn-sm btn-outline-light text-info rounded-2"
                              style={{ padding: "0.3rem" }}
                              disabled={
                                item?.movement_status?.toLowerCase() !==
                                "approved"
                              }
                              onClick={() => {
                                setActionType("accept");
                                setSelectedData(item);
                                handleToggleModal();
                              }}
                            >
                              <IoIosCheckmarkCircle
                                className="text-success"
                                size={19}
                              />
                            </button>
                          </CustomTooltip>

                          <CustomTooltip title="Reject" placement="top">
                            <button
                              className="btn btn-sm btn-outline-light text-danger rounded-2"
                              style={{ padding: "0.3rem" }}
                              disabled={
                                item?.movement_status?.toLowerCase() !==
                                "approved"
                              }
                              onClick={() => {
                                setActionType("reject");
                                setSelectedData(item);
                                handleToggleModal();
                              }}
                            >
                              <MdCancel className="text-danger" size={19} />
                            </button>
                          </CustomTooltip>
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center my-4">
            <span>No data found</span>
          </div>
        )}
        {!loading && assets?.length > 0 && (
          <div className="p-4">
            <Pagination
              currentPage={param.page}
              recordsPage={param.page_size}
              dataLength={total}
              handlePagination={handlePageChange}
            />
          </div>
        )}
      </div>
      <EmployeeAssetTransferAction
        actionType={actionType}
        open={showModal}
        onClose={handleToggleModal}
        afterSubmit={handleAfterTransferActionSubmit}
        assetData={selecetdData}
      />
    </>
  );
};

export default AssetTransferRequest;
